import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.selectKit.isExpanded}}\n  {{yield}}\n{{/if}}", {
  moduleName: "select-kit/components/select-kit/select-kit-body.hbs"
});